import { createSlice } from "@reduxjs/toolkit";

import { getcronjobetails, getSystemPrompt, setSystemPrompt } from "./Otherservices.Action";
const initialState = {
  isLoading: false,
  isCreateLoading: false,
  isSuccess: false,
  isError: false,
  currentduration: 604800000,
  durationsetin: "week",
  isLicenceVisible:false,
  LicenceModalType:"",
  ispromptLoading:false,
  ispromptSubmiiting:false,
  promptData:{}

};
const OtherservicesSlice = createSlice({
  name: "OtherservicesSlice",
  initialState: initialState,
  reducers: {
    setLicenceModalVisible: (state, { payload }) => {
      state.isLicenceVisible = payload.visible;
      state.LicenceModalType = payload?.type || "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getcronjobetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getcronjobetails.fulfilled, (state, { payload }) => {
        state.currentduration = payload?.data?.duration||604800000;
        
        if ((payload?.data?.duration||604800000 / 604800000) % 1 === 0) {
          state.durationsetin = "week";
        } else {
          state.durationsetin = "day";
        }
      })
      .addCase(getcronjobetails.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
        .addCase(getSystemPrompt.pending, (state) => {
        state.ispromptLoading = true;
      })
      .addCase(getSystemPrompt.fulfilled, (state, { payload }) => {
        state.ispromptLoading = false;
        state.promptData=payload?.data||{}
 
      })
      .addCase(getSystemPrompt.rejected, (state, { payload }) => {
        state.ispromptLoading = false;
      })
       .addCase(setSystemPrompt.pending, (state) => {
        state.ispromptSubmiiting = true;
      })
      .addCase(setSystemPrompt.fulfilled, (state, { payload }) => {
        state.ispromptSubmiiting= false;
 
      })
      .addCase(setSystemPrompt.rejected, (state, { payload }) => {
        state.ispromptSubmiiting = false;
      })
  },
});
 export const {setLicenceModalVisible} = OtherservicesSlice.actions;

export default OtherservicesSlice.reducer;
